import { browser } from "$app/environment";

import { createLogger } from "../logger";

const logger = createLogger("init");

import { initSentry } from "../sentry";
import { recordStatsEvent } from "../stats";

export const prerender = false;
export const ssr = false;

if (browser) {
  const MODE = import.meta.env.MODE;
  const BUILD_NAME = import.meta.env.BUILD_NAME;
  const BUILD_SHA = import.meta.env.BUILD_SHA;
  const BUILD_DATE = import.meta.env.BUILD_DATE;

  initSentry({
    dsn: "https://1e2259e7343f4de2ae1ba26f6ba8744a@sentry-relay.opera-api.com/232",
    environment: MODE,
    release: BUILD_NAME,
  });

  recordStatsEvent({ name: "page-load" });

  // eslint-disable-next-line no-console
  logger.info(`Build: ${BUILD_NAME} (${BUILD_SHA}) ${MODE} @ ${BUILD_DATE}`);
}
